// extracted by mini-css-extract-plugin
export default {"issueTypeDot":"DefaultIssueTypePickerAnchor-module__issueTypeDot__aopd3y1"};